var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{staticClass:"mr-2 btn details_btn",attrs:{"to":{
      path: `/Retail-Outlet/tank-probe-transactions/${_vm.data.tankId}`,
      query: {
        branchId: _vm.data.branchId,
        tankId: _vm.data.tankId,
        companyId: _vm.$route.query.companyId,
      },
    }}},[_vm._v(_vm._s(_vm.$t("text.tanks.probeTransactions")))]),_vm._v(" "),(_vm.data.manualOpeningVolume > 0 || _vm.data.manualLastVolume > 0)?_c('button',{staticClass:"btn details_btn",style:({ cursor: _vm.loadingDeny ? 'not-allowed' : '' }),attrs:{"disabled":_vm.loadingDeny},on:{"click":function($event){return _vm.rejectData($event)}}},[(!_vm.loadingDeny)?_c('span',[_vm._v(_vm._s(_vm.$t("text.clickButtons.reject")))]):_vm._e(),_vm._v(" "),(_vm.loadingDeny)?_c('pulse-loader',{attrs:{"size":"7px"}}):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }